export const PRECALCULATED_HANDS = {
	"": {
		"Royal Flush": 4324,
		"Straight Flush": 37260,
		"Four of a Kind": 224848,
		"Full House": 3473184,
		"Flush": 4047644,
		"Straight": 6180020,
		"Three of a Kind": 6461620,
		"Two Pair": 31433400,
		"One Pair": 58627800,
		"No Pair": 23294460
	},
	"As": {
		"Royal Flush": 1219,
		"Straight Flush": 2565,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 546689,
		"Straight": 601643,
		"Three of a Kind": 873103,
		"Two Pair": 4246074,
		"One Pair": 8004150,
		"No Pair": 3236205
	},
	"2s": {
		"Royal Flush": 184,
		"Straight Flush": 3600,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 546689,
		"Straight": 601643,
		"Three of a Kind": 873103,
		"Two Pair": 4246074,
		"One Pair": 8004150,
		"No Pair": 3236205
	},
	"3s": {
		"Royal Flush": 184,
		"Straight Flush": 4590,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 545699,
		"Straight": 731997,
		"Three of a Kind": 871332,
		"Two Pair": 4238136,
		"One Pair": 7941780,
		"No Pair": 3177930
	},
	"4s": {
		"Royal Flush": 184,
		"Straight Flush": 5580,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 544709,
		"Straight": 862351,
		"Three of a Kind": 869561,
		"Two Pair": 4230198,
		"One Pair": 7879410,
		"No Pair": 3119655
	},
	"5s": {
		"Royal Flush": 184,
		"Straight Flush": 6570, // mystery: why does 5 have more straights than 6, 7, 8, 9
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543719,
		"Straight": 992705,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7817040,
		"No Pair": 3061380
	},
	"6s": {
		"Royal Flush": 184,
		"Straight Flush": 6525,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543764,
		"Straight": 959000,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7827435,
		"No Pair": 3084690
	},
	"7s": {
		"Royal Flush": 184,
		"Straight Flush": 6525,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543764,
		"Straight": 959000,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7827435,
		"No Pair": 3084690
	},
	"8s": {
		"Royal Flush": 184,
		"Straight Flush": 6525,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543764,
		"Straight": 959000,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7827435,
		"No Pair": 3084690
	},
	"9s": {
		"Royal Flush": 184,
		"Straight Flush": 6525,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543764,
		"Straight": 959000,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7827435,
		"No Pair": 3084690
	},
	"10s": {
		"Royal Flush": 1219,
		"Straight Flush": 5535,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 543719,
		"Straight": 992705,
		"Three of a Kind": 867790,
		"Two Pair": 4222260,
		"One Pair": 7817040,
		"No Pair": 3061380
	},
	"Js": {
		"Royal Flush": 1219,
		"Straight Flush": 4545,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 544709,
		"Straight": 862351,
		"Three of a Kind": 869561,
		"Two Pair": 4230198,
		"One Pair": 7879410,
		"No Pair": 3119655
	},
	"Qs": {
		"Royal Flush": 1219,
		"Straight Flush": 3555,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 545699,
		"Straight": 731997,
		"Three of a Kind": 871332,
		"Two Pair": 4238136,
		"One Pair": 7941780,
		"No Pair": 3177930
	},
	"Ks": {
		"Royal Flush": 1219,
		"Straight Flush": 2565,
		"Four of a Kind": 30268,
		"Full House": 467544,
		"Flush": 546689,
		"Straight": 601643,
		"Three of a Kind": 873103,
		"Two Pair": 4246074,
		"One Pair": 8004150,
		"No Pair": 3236205
	},
	"As Ah": {
		"Royal Flush": 94,
		"Straight Flush": 122,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41562,
		"Straight": 25816,
		"Three of a Kind": 249458,
		"Two Pair": 840456,
		"One Pair": 762300,
		"No Pair": 0
	},
	"2s As": {
		"Royal Flush": 49,
		"Straight Flush": 1113,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138296,
		"Straight": 65508,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 916776,
		"No Pair": 386130
	},
	"2s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 167,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41562,
		"Straight": 69954,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 965568,
		"No Pair": 417780
	},
	"2s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 212,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41562,
		"Straight": 25816,
		"Three of a Kind": 249458,
		"Two Pair": 840456,
		"One Pair": 762300,
		"No Pair": 0
	},
	"3s As": {
		"Royal Flush": 49,
		"Straight Flush": 1157,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138252,
		"Straight": 72939,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 913920,
		"No Pair": 381555
	},
	"3s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 211,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 77912,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 962560,
		"No Pair": 412830
	},
	"3s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 2148,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137306,
		"Straight": 99573,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 899640,
		"No Pair": 372405
	},
	"3s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 256,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 106134,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 947520,
		"No Pair": 402930
	},
	"3s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 300,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41474,
		"Straight": 33774,
		"Three of a Kind": 248952,
		"Two Pair": 838944,
		"One Pair": 756360,
		"No Pair": 0
	},
	"4s As": {
		"Royal Flush": 49,
		"Straight Flush": 1201,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138208,
		"Straight": 80370,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 911064,
		"No Pair": 376980
	},
	"4s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 85870,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 959552,
		"No Pair": 407880
	},
	"4s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 2192,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137262,
		"Straight": 107004,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 896784,
		"No Pair": 367830
	},
	"4s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 300,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 114092,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 944512,
		"No Pair": 397980
	},
	"4s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 3182,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136272,
		"Straight": 141069,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 879648,
		"No Pair": 354105
	},
	"4s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 344,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 150272,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 926464,
		"No Pair": 383130
	},
	"4s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 388,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41386,
		"Straight": 41732,
		"Three of a Kind": 248446,
		"Two Pair": 837432,
		"One Pair": 750420,
		"No Pair": 0
	},
	"5s As": {
		"Royal Flush": 49,
		"Straight Flush": 1245,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138164,
		"Straight": 87801,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 908208,
		"No Pair": 372405
	},
	"5s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 93828,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 956544,
		"No Pair": 402930
	},
	"5s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 2236,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137218,
		"Straight": 114435,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 893928,
		"No Pair": 363255
	},
	"5s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 344,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 122050,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 941504,
		"No Pair": 393030
	},
	"5s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 3226,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136228,
		"Straight": 148500,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 876792,
		"No Pair": 349530
	},
	"5s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 388,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41386,
		"Straight": 158230,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 923456,
		"No Pair": 378180
	},
	"5s 4s": {
		"Royal Flush": 4,
		"Straight Flush": 4216,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135238,
		"Straight": 182565,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 335805
	},
	"5s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 432,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41342,
		"Straight": 194410,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 363330
	},
	"5s 5h": {
		"Royal Flush": 4,
		"Straight Flush": 476,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41298,
		"Straight": 49690,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 744480,
		"No Pair": 0
	},
	"6s As": {
		"Royal Flush": 49,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139155,
		"Straight": 52821,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 387045
	},
	"6s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 56658,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 418770
	},
	"6s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 1245,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138209,
		"Straight": 79455,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 911064,
		"No Pair": 377895
	},
	"6s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 84880,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 959552,
		"No Pair": 408870
	},
	"6s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 2235,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137219,
		"Straight": 113520,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 893928,
		"No Pair": 364170
	},
	"6s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 121060,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 941504,
		"No Pair": 394020
	},
	"6s 4s": {
		"Royal Flush": 4,
		"Straight Flush": 3225,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136229,
		"Straight": 147585,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 876792,
		"No Pair": 350445
	},
	"6s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 431,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 157240,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 923456,
		"No Pair": 379170
	},
	"6s 5s": {
		"Royal Flush": 4,
		"Straight Flush": 4215,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135239,
		"Straight": 181650,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 336720
	},
	"6s 5h": {
		"Royal Flush": 4,
		"Straight Flush": 475,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 193420,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 364320
	},
	"6s 6h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41300,
		"Straight": 48700,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 745470,
		"No Pair": 0
	},
	"7s As": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"7s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"7s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139155,
		"Straight": 52821,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 387045
	},
	"7s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 56658,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 418770
	},
	"7s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 1289,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138165,
		"Straight": 86886,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 908208,
		"No Pair": 373320
	},
	"7s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 92838,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 956544,
		"No Pair": 403920
	},
	"7s 4s": {
		"Royal Flush": 4,
		"Straight Flush": 2279,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137175,
		"Straight": 120951,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 891072,
		"No Pair": 359595
	},
	"7s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 431,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 129018,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 938496,
		"No Pair": 389070
	},
	"7s 5s": {
		"Royal Flush": 4,
		"Straight Flush": 3269,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136185,
		"Straight": 155016,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 873936,
		"No Pair": 345870
	},
	"7s 5h": {
		"Royal Flush": 4,
		"Straight Flush": 475,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 165198,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 920448,
		"No Pair": 374220
	},
	"7s 6s": {
		"Royal Flush": 4,
		"Straight Flush": 4214,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135240,
		"Straight": 180735,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 337635
	},
	"7s 6h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 192430,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 365310
	},
	"7s 7h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41300,
		"Straight": 48700,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 745470,
		"No Pair": 0
	},
	"8s As": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"8s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"8s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"8s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"8s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"8s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"8s 4s": {
		"Royal Flush": 4,
		"Straight Flush": 1333,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138121,
		"Straight": 94317,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 905352,
		"No Pair": 368745
	},
	"8s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 431,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 100796,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 953536,
		"No Pair": 398970
	},
	"8s 5s": {
		"Royal Flush": 4,
		"Straight Flush": 2323,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137131,
		"Straight": 128382,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 888216,
		"No Pair": 355020
	},
	"8s 5h": {
		"Royal Flush": 4,
		"Straight Flush": 475,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 136976,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 935488,
		"No Pair": 384120
	},
	"8s 6s": {
		"Royal Flush": 4,
		"Straight Flush": 3268,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136186,
		"Straight": 154101,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 873936,
		"No Pair": 346785
	},
	"8s 6h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 164208,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 920448,
		"No Pair": 375210
	},
	"8s 7s": {
		"Royal Flush": 4,
		"Straight Flush": 4214,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135240,
		"Straight": 180735,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 337635
	},
	"8s 7h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 192430,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 365310
	},
	"8s 8h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41300,
		"Straight": 48700,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 745470,
		"No Pair": 0
	},
	"9s As": {
		"Royal Flush": 49,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139155,
		"Straight": 52821,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 387045
	},
	"9s Ah": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 56658,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 418770
	},
	"9s 2s": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"9s 2h": {
		"Royal Flush": 4,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"9s 3s": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139067,
		"Straight": 67683,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 377895
	},
	"9s 3h": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 72574,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 408870
	},
	"9s 4s": {
		"Royal Flush": 4,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139067,
		"Straight": 67683,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 377895
	},
	"9s 4h": {
		"Royal Flush": 4,
		"Straight Flush": 431,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 72574,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 408870
	},
	"9s 5s": {
		"Royal Flush": 4,
		"Straight Flush": 1377,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138077,
		"Straight": 101748,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 902496,
		"No Pair": 364170
	},
	"9s 5h": {
		"Royal Flush": 4,
		"Straight Flush": 475,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 108754,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 950528,
		"No Pair": 394020
	},
	"9s 6s": {
		"Royal Flush": 4,
		"Straight Flush": 2322,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137132,
		"Straight": 127467,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 888216,
		"No Pair": 355935
	},
	"9s 6h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 135986,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 935488,
		"No Pair": 385110
	},
	"9s 7s": {
		"Royal Flush": 4,
		"Straight Flush": 3268,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136186,
		"Straight": 154101,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 873936,
		"No Pair": 346785
	},
	"9s 7h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 164208,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 920448,
		"No Pair": 375210
	},
	"9s 8s": {
		"Royal Flush": 4,
		"Straight Flush": 4214,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135240,
		"Straight": 180735,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 337635
	},
	"9s 8h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41300,
		"Straight": 192430,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 365310
	},
	"9s 9h": {
		"Royal Flush": 4,
		"Straight Flush": 474,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41300,
		"Straight": 48700,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 745470,
		"No Pair": 0
	},
	"10s As": {
		"Royal Flush": 1084,
		"Straight Flush": 210,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138164,
		"Straight": 87801,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 908208,
		"No Pair": 372405
	},
	"10s Ah": {
		"Royal Flush": 94,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 93828,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 956544,
		"No Pair": 402930
	},
	"10s 2s": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139110,
		"Straight": 61167,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 381555
	},
	"10s 2h": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 65606,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 412830
	},
	"10s 3s": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139066,
		"Straight": 68598,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 376980
	},
	"10s 3h": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41386,
		"Straight": 73564,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 407880
	},
	"10s 4s": {
		"Royal Flush": 49,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139022,
		"Straight": 76029,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 916776,
		"No Pair": 372405
	},
	"10s 4h": {
		"Royal Flush": 49,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41342,
		"Straight": 81522,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 965568,
		"No Pair": 402930
	},
	"10s 5s": {
		"Royal Flush": 49,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139022,
		"Straight": 76029,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 916776,
		"No Pair": 372405
	},
	"10s 5h": {
		"Royal Flush": 49,
		"Straight Flush": 431,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41298,
		"Straight": 81522,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 965568,
		"No Pair": 402930
	},
	"10s 6s": {
		"Royal Flush": 49,
		"Straight Flush": 1332,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138077,
		"Straight": 101748,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 902496,
		"No Pair": 364170
	},
	"10s 6h": {
		"Royal Flush": 49,
		"Straight Flush": 430,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 108754,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 950528,
		"No Pair": 394020
	},
	"10s 7s": {
		"Royal Flush": 49,
		"Straight Flush": 2278,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137131,
		"Straight": 128382,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 888216,
		"No Pair": 355020
	},
	"10s 7h": {
		"Royal Flush": 49,
		"Straight Flush": 430,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 136976,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 935488,
		"No Pair": 384120
	},
	"10s 8s": {
		"Royal Flush": 49,
		"Straight Flush": 3224,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136185,
		"Straight": 155016,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 873936,
		"No Pair": 345870
	},
	"10s 8h": {
		"Royal Flush": 49,
		"Straight Flush": 430,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 165198,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 920448,
		"No Pair": 374220
	},
	"10s 9s": {
		"Royal Flush": 49,
		"Straight Flush": 4170,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135239,
		"Straight": 181650,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 336720
	},
	"10s 9h": {
		"Royal Flush": 49,
		"Straight Flush": 430,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41299,
		"Straight": 193420,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 364320
	},
	"10s 10h": {
		"Royal Flush": 94,
		"Straight Flush": 386,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41298,
		"Straight": 49690,
		"Three of a Kind": 247940,
		"Two Pair": 835920,
		"One Pair": 744480,
		"No Pair": 0
	},
	"Js As": {
		"Royal Flush": 1084,
		"Straight Flush": 166,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138208,
		"Straight": 80370,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 911064,
		"No Pair": 376980
	},
	"Js Ah": {
		"Royal Flush": 94,
		"Straight Flush": 210,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 85870,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 959552,
		"No Pair": 407880
	},
	"Js 2s": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139154,
		"Straight": 53736,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 386130
	},
	"Js 2h": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 57648,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 417780
	},
	"Js 3s": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139110,
		"Straight": 61167,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 381555
	},
	"Js 3h": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 65606,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 412830
	},
	"Js 4s": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139066,
		"Straight": 68598,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 376980
	},
	"Js 4h": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41386,
		"Straight": 73564,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 407880
	},
	"Js 5s": {
		"Royal Flush": 49,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139022,
		"Straight": 76029,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 916776,
		"No Pair": 372405
	},
	"Js 5h": {
		"Royal Flush": 49,
		"Straight Flush": 387,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41342,
		"Straight": 81522,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 965568,
		"No Pair": 402930
	},
	"Js 6s": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139067,
		"Straight": 67683,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 377895
	},
	"Js 6h": {
		"Royal Flush": 49,
		"Straight Flush": 386,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 72574,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 408870
	},
	"Js 7s": {
		"Royal Flush": 49,
		"Straight Flush": 1288,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138121,
		"Straight": 94317,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 905352,
		"No Pair": 368745
	},
	"Js 7h": {
		"Royal Flush": 49,
		"Straight Flush": 386,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 100796,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 953536,
		"No Pair": 398970
	},
	"Js 8s": {
		"Royal Flush": 49,
		"Straight Flush": 2234,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137175,
		"Straight": 120951,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 891072,
		"No Pair": 359595
	},
	"Js 8h": {
		"Royal Flush": 49,
		"Straight Flush": 386,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 129018,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 938496,
		"No Pair": 389070
	},
	"Js 9s": {
		"Royal Flush": 49,
		"Straight Flush": 3180,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136229,
		"Straight": 147585,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 876792,
		"No Pair": 350445
	},
	"Js 9h": {
		"Royal Flush": 49,
		"Straight Flush": 386,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41343,
		"Straight": 157240,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 923456,
		"No Pair": 379170
	},
	"Js 10s": {
		"Royal Flush": 1084,
		"Straight Flush": 3136,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 135238,
		"Straight": 182565,
		"Three of a Kind": 90321,
		"Two Pair": 461163,
		"One Pair": 859656,
		"No Pair": 335805
	},
	"Js 10h": {
		"Royal Flush": 94,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41342,
		"Straight": 194410,
		"Three of a Kind": 92092,
		"Two Pair": 471950,
		"One Pair": 905408,
		"No Pair": 363330
	},
	"Js Jh": {
		"Royal Flush": 94,
		"Straight Flush": 298,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41386,
		"Straight": 41732,
		"Three of a Kind": 248446,
		"Two Pair": 837432,
		"One Pair": 750420,
		"No Pair": 0
	},
	"Qs As": {
		"Royal Flush": 1084,
		"Straight Flush": 122,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138252,
		"Straight": 72939,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 913920,
		"No Pair": 381555
	},
	"Qs Ah": {
		"Royal Flush": 94,
		"Straight Flush": 166,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 77912,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 962560,
		"No Pair": 412830
	},
	"Qs 2s": {
		"Royal Flush": 49,
		"Straight Flush": 211,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139198,
		"Straight": 46305,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 928200,
		"No Pair": 390705
	},
	"Qs 2h": {
		"Royal Flush": 49,
		"Straight Flush": 211,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 49690,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 977600,
		"No Pair": 422730
	},
	"Qs 3s": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139154,
		"Straight": 53736,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 386130
	},
	"Qs 3h": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 57648,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 417780
	},
	"Qs 4s": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139110,
		"Straight": 61167,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 381555
	},
	"Qs 4h": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 65606,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 412830
	},
	"Qs 5s": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139066,
		"Straight": 68598,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 376980
	},
	"Qs 5h": {
		"Royal Flush": 49,
		"Straight Flush": 343,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41386,
		"Straight": 73564,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 407880
	},
	"Qs 6s": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139067,
		"Straight": 67683,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 919632,
		"No Pair": 377895
	},
	"Qs 6h": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 72574,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 968576,
		"No Pair": 408870
	},
	"Qs 7s": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"Qs 7h": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"Qs 8s": {
		"Royal Flush": 49,
		"Straight Flush": 1244,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138165,
		"Straight": 86886,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 908208,
		"No Pair": 373320
	},
	"Qs 8h": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 92838,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 956544,
		"No Pair": 403920
	},
	"Qs 9s": {
		"Royal Flush": 49,
		"Straight Flush": 2190,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137219,
		"Straight": 113520,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 893928,
		"No Pair": 364170
	},
	"Qs 9h": {
		"Royal Flush": 49,
		"Straight Flush": 342,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41387,
		"Straight": 121060,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 941504,
		"No Pair": 394020
	},
	"Qs 10s": {
		"Royal Flush": 1084,
		"Straight Flush": 2146,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136228,
		"Straight": 148500,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 876792,
		"No Pair": 349530
	},
	"Qs 10h": {
		"Royal Flush": 94,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41386,
		"Straight": 158230,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 923456,
		"No Pair": 378180
	},
	"Qs Js": {
		"Royal Flush": 1084,
		"Straight Flush": 2102,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 136272,
		"Straight": 141069,
		"Three of a Kind": 90882,
		"Two Pair": 463806,
		"One Pair": 879648,
		"No Pair": 354105
	},
	"Qs Jh": {
		"Royal Flush": 94,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 150272,
		"Three of a Kind": 92664,
		"Two Pair": 474660,
		"One Pair": 926464,
		"No Pair": 383130
	},
	"Qs Qh": {
		"Royal Flush": 94,
		"Straight Flush": 210,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41474,
		"Straight": 33774,
		"Three of a Kind": 248952,
		"Two Pair": 838944,
		"One Pair": 756360,
		"No Pair": 0
	},
	"Ks As": {
		"Royal Flush": 1084,
		"Straight Flush": 78,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138296,
		"Straight": 65508,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 916776,
		"No Pair": 386130
	},
	"Ks Ah": {
		"Royal Flush": 94,
		"Straight Flush": 122,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41562,
		"Straight": 69954,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 965568,
		"No Pair": 417780
	},
	"Ks 2s": {
		"Royal Flush": 49,
		"Straight Flush": 167,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139242,
		"Straight": 38874,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 931056,
		"No Pair": 395280
	},
	"Ks 2h": {
		"Royal Flush": 49,
		"Straight Flush": 167,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41562,
		"Straight": 41732,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 980608,
		"No Pair": 427680
	},
	"Ks 3s": {
		"Royal Flush": 49,
		"Straight Flush": 211,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139198,
		"Straight": 46305,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 928200,
		"No Pair": 390705
	},
	"Ks 3h": {
		"Royal Flush": 49,
		"Straight Flush": 211,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 49690,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 977600,
		"No Pair": 422730
	},
	"Ks 4s": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139154,
		"Straight": 53736,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 386130
	},
	"Ks 4h": {
		"Royal Flush": 49,
		"Straight Flush": 255,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 57648,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 417780
	},
	"Ks 5s": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139110,
		"Straight": 61167,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 381555
	},
	"Ks 5h": {
		"Royal Flush": 49,
		"Straight Flush": 299,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 65606,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 412830
	},
	"Ks 6s": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"Ks 6h": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"Ks 7s": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139111,
		"Straight": 60252,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 922488,
		"No Pair": 382470
	},
	"Ks 7h": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 64616,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 971584,
		"No Pair": 413820
	},
	"Ks 8s": {
		"Royal Flush": 49,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 139155,
		"Straight": 52821,
		"Three of a Kind": 92565,
		"Two Pair": 471735,
		"One Pair": 925344,
		"No Pair": 387045
	},
	"Ks 8h": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 56658,
		"Three of a Kind": 94380,
		"Two Pair": 482790,
		"One Pair": 974592,
		"No Pair": 418770
	},
	"Ks 9s": {
		"Royal Flush": 49,
		"Straight Flush": 1200,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 138209,
		"Straight": 79455,
		"Three of a Kind": 92004,
		"Two Pair": 469092,
		"One Pair": 911064,
		"No Pair": 377895
	},
	"Ks 9h": {
		"Royal Flush": 49,
		"Straight Flush": 298,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41431,
		"Straight": 84880,
		"Three of a Kind": 93808,
		"Two Pair": 480080,
		"One Pair": 959552,
		"No Pair": 408870
	},
	"Ks 10s": {
		"Royal Flush": 1084,
		"Straight Flush": 1156,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137218,
		"Straight": 114435,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 893928,
		"No Pair": 363255
	},
	"Ks 10h": {
		"Royal Flush": 94,
		"Straight Flush": 254,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41430,
		"Straight": 122050,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 941504,
		"No Pair": 393030
	},
	"Ks Js": {
		"Royal Flush": 1084,
		"Straight Flush": 1112,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137262,
		"Straight": 107004,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 896784,
		"No Pair": 367830
	},
	"Ks Jh": {
		"Royal Flush": 94,
		"Straight Flush": 210,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41474,
		"Straight": 114092,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 944512,
		"No Pair": 397980
	},
	"Ks Qs": {
		"Royal Flush": 1084,
		"Straight Flush": 1068,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 137306,
		"Straight": 99573,
		"Three of a Kind": 91443,
		"Two Pair": 466449,
		"One Pair": 899640,
		"No Pair": 372405
	},
	"Ks Qh": {
		"Royal Flush": 94,
		"Straight Flush": 166,
		"Four of a Kind": 2668,
		"Full House": 47124,
		"Flush": 41518,
		"Straight": 106134,
		"Three of a Kind": 93236,
		"Two Pair": 477370,
		"One Pair": 947520,
		"No Pair": 402930
	},
	"Ks Kh": {
		"Royal Flush": 94,
		"Straight Flush": 122,
		"Four of a Kind": 17848,
		"Full House": 181104,
		"Flush": 41562,
		"Straight": 25816,
		"Three of a Kind": 249458,
		"Two Pair": 840456,
		"One Pair": 762300,
		"No Pair": 0
	}
}